__turbopack_context__.v({
  "className": "fredoka_635a96d0-module__XqeJ4q__className",
});
